// Vue and Router
import Vue from "vue";
import Router from "vue-router";

// Pages
const AsyncDashboard = () => import("../pages/Dashboard");
const AsyncDetails = () => import("../pages/Details.vue");
const AsyncNomatch = () => import("../pages/NoMatch");
const AsyncFaq = () => import("../pages/Faq.vue");
const AsyncSfdc = () => import("../pages/Sfdc.vue");
const AsyncLiveDashboardTraker = () =>
  import("../pages/LiveDashboardTraker.vue");
const AsyncUserProfile = () => import("../pages/UserProfile.vue");

// Using the Router Vue Plugin/Package
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: AsyncDashboard,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/dispute-case-details/:id",
      name: "Details",
      component: AsyncDetails,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/faq",
      name: "Faq",
      component: AsyncNomatch,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/create-dispute",
      name: "Sfdc",
      component: AsyncSfdc,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/dashboard-tracker",
      name: "LiveDashboardTraker",
      component: AsyncLiveDashboardTraker,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/user-profile",
      name: "UserProfile",
      component: AsyncUserProfile,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "*",
      name: "nomatch",
      component: AsyncFaq,
      meta: {
        requireAuth: true,
      },
    },
  ],
});
